export const TAX_ID_INPUT = 'taxIdInput';